"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._RecordsEvent = {
    type: "structure",
    required: [],
    members: {
        Payload: {
            shape: {
                type: "blob"
            }
        }
    }
};
//# sourceMappingURL=_RecordsEvent.js.map